import { render, staticRenderFns } from "./TableResultKpi.vue?vue&type=template&id=180a3bda"
import script from "./TableResultKpi.vue?vue&type=script&lang=js"
export * from "./TableResultKpi.vue?vue&type=script&lang=js"
import style0 from "./TableResultKpi.vue?vue&type=style&index=0&id=180a3bda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports